export default {
  selection: "系統語言選擇",
  english: "English",
  simplified_chinese: "中文（简体）",
  list: {
    en: "英語",
    zh: "中文（中國）",
    tw: "中文（台灣）",
    vi: "越南語",
    th: "泰語",
    id: "印尼語",
    malay: "馬來語",
    jp: "日語",
    kr: "韓語",
    my: "緬甸語",
    ar: "阿根廷語",
    ru: "俄語",
    ne: "尼泊爾",
    bn: "孟加拉語"
  }
};
